import { ChevronRight } from "lucide-react";
import { BackgroundImage } from "@/components/backgroundImage";
import { ShinyText } from "@/components/shinyText";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ViewBuscarAtendimentos } from "@/components/viewBuscarAtendimentos";
import { PopupDisplay } from "@/components/popUp";

function Home() {
  const navigate = useNavigate();

  function handleIniciar() {
    navigate("/unidade", { state: { can_stay: true } });
  }

  return (
    <div className="px-4 pb-8 pt-6 flex flex-col items-center gap-4">
      <PopupDisplay />

      <div className="mx-auto w-full max-w-[500px] lg:max-w-2xl xl:max-w-3xl">
        {/* <HeaderBanner /> */}

        <div className="flex justify-center py-2 mb-4">
          <img src="/logo.png" alt="logo" className="w-[180px] lg:w-[220px]" />
        </div>

        <div className="flex flex-col items-center gap-4 px-4">
          <BackgroundImage
            alt="browsers-pana.png"
            src="/assets/browsers-pana.png"
            height="h-[320px] lg:h-[460px]"
          />

          <div className="flex flex-col items-center mt-4">
            <ShinyText label="Bem-vindo à" />
            <p className="text-3xl lg:text-4xl xl:text-5xl font-bold text-center mt-2">
              Secretaria Digital
            </p>
          </div>

          <div className="flex flex-col gap-2 w-full max-w-[400px] mt-4">
            <Button
              onClick={handleIniciar}
              size="lg"
              className="w-full cursor-pointer"
            >
              Iniciar Atendimento
              <ChevronRight />
            </Button>
            <ViewBuscarAtendimentos>
              <Button variant="outline" className="w-full">
                Ver atendimentos
              </Button>
            </ViewBuscarAtendimentos>
          </div>
        </div>
      </div>

      {/* <SideBanner /> */}
    </div>
  );
}

export default Home;
